import { jsx as o, jsxs as p } from "react/jsx-runtime";
import { Tooltip as k } from "@systemeio/ui";
import { useEditorState as u } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as g } from "react";
import { twMerge as r } from "tailwind-merge";
import { ToolbarButton as c } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as t, TOOLTIP_STYLES as I } from "../../constants/default-styles.mjs";
import b from "../../icons/link-icon.mjs";
import { useTranslation as T } from "../../i18n.mjs";
import { LinkBubbleMenu as L } from "./link-bubble-menu.mjs";
import { isImageSelected as h } from "../image-extension/utils/is-image-selected.mjs";
const O = (i, m, f) => {
  const { t: e } = T(), n = u({
    editor: i,
    selector: ({ editor: s }) => ({
      isEditable: (s == null ? void 0 : s.options.editable) ?? !1,
      isActive: s == null ? void 0 : s.isActive("link"),
      isImageSelected: h(s)
    })
  }), a = (n == null ? void 0 : n.isActive) ?? !1, l = !(n != null && n.isEditable) || !!(n != null && n.isImageSelected);
  return g(() => {
    const s = () => {
      if (!i) return null;
      i.isActive("link") ? i.chain().focus() : i.chain().focus().extendMarkRange("link").setLink({ href: "" }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ o(k, { disabled: l, label: e("link"), ...I, children: /* @__PURE__ */ o(
        c,
        {
          disabled: l,
          className: r(a && "bg-brand-primary/10 main-transition-colors"),
          onClick: s,
          children: /* @__PURE__ */ o(b, { className: t(l) })
        }
      ) }),
      tooltipRender: /* @__PURE__ */ p(
        c,
        {
          disabled: l,
          className: r(
            a && "bg-brand-primary/10 main-transition-colors",
            "flex gap-1"
          ),
          onClick: s,
          children: [
            /* @__PURE__ */ o(b, { className: t(l) }),
            e("link")
          ]
        }
      ),
      additionalRender: /* @__PURE__ */ o(L, { editor: i, fileSource: m })
    };
  }, [i, m, a, l, f, e]);
};
export {
  O as useLinkExtensionToolbar
};
